const currencySymbols = {
  usd: '$',
  'United States Dollar': '$',
  ethereum: 'ETH',
  binancecoin: 'BNB',
}

export const getCurrencySybol = (currency: string) => (
  currencySymbols[currency] || currency || ''
)
